import React from 'react'
import './Sec8Role.css'

function Sec8Role() {
  return (
    <div className='Sec8Role container'>
      <h3 className='Sec8Role-title'>Role of the Indian Government</h3>
      <p className='Sec8Role-para'>The role of the Indian government in cultivating this ecosystem cannot be overstated. Their receptiveness to industry feedback and their initiative in developing favorable policies in critical areas such as Research & Development, Intellectual Property creation, and overall ease of doing business have significantly enhanced the trust and confidence of MNCs in the Indian market.</p>
    </div>
  )
}

export default Sec8Role
